<template>
  <div>
    <breadcrumbs home="Shipment zone"/>

    <v-card flat width="100%">
      <v-form v-model="valid" ref="form">
        <v-container class="px-6 pt-8 purtrak-scrollable" fluid>

          <v-row dense>
            <v-col cols="6" sm="4" md="2">
              <v-text-field label="Name" v-model="shipmentZone.name" :rules="[fieldRules.required,fieldRules.maxLength(20)]" :counter="20" outlined dense/>
            </v-col>
            <v-col cols="2" lg="1">
              <v-checkbox label="Active" v-model="shipmentZone.active" class="mt-1"/>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" :loading="saving" @click="save">Save</v-btn>
      </v-card-actions>
    </v-card>

    <confirm-leave v-model="next"/>
  </div>
</template>

<script>
import confirmLeave from '@/mixins/confirmLeave'

export default {
  name: 'ShipmentZoneEdit',
  mixins: [confirmLeave],
  props: {
    shipmentZoneId: {type:String, required:false}
  },
  data() {
    return {
      shipmentZone: {active:true,name:''},
      valid: true,
      dirty: false,
      saving: false
    }
  },
  watch: {
    shipmentZone: {
      handler() {this.dirty = true;},
      immediate: true,
      deep: true
    }
  },

  async created() {
    if (this.shipmentZoneId) {
      const results = await this.$apiCall(`query ShipmentZonesEdit($id:ID!) {
                                                shipmentZone(id:$id) {
                                                  id,name,active
                                                }
                                              }`,
                                          {id:this.shipmentZoneId});
      if (results.error) {
        this.$nextTick(() => this.dirty = false);
        this.$router.back();
        return;
      }
      this.shipmentZone = results.data.shipmentZone;
      this.$nextTick(() => this.dirty = false);
    }
  },
  mounted() {
    this.$refs.form.validate();
  },

  methods: {
    cancel() {
      this.$router.back();
    },
    async save() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      this.saving = true;
      const results = await this.$apiCall(`mutation ShipmentZonesEdit($input: ShipmentZoneInput!) {
                                             shipmentZoneCrupdate(input:$input) {id}
                                           }`,
                                          {input:this.shipmentZone})
      this.saving = false;
      if (results.error)
        return;

      this.$nextTick(() => {
        this.dirty = false;
        this.$router.back();
        this.$store.commit('setError', {type:'success',message:`${this.shipmentZoneId?'Updated':'Created'} shipment zone ${this.shipmentZone.name}`});
      });
    },
  }
}
</script>